import serverFetch from "../utils/serverFetch";
import config from "../app-config";

export const create_new_role = async (payload) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role`,
        method: "POST",
        body: JSON.stringify(payload),
    }))
}

export const fetch_all_roles = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role`,
        method: "GET",
    }))
}

export const fetch_role_by_id = async (role_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role/id/${role_id}`,
        method: "GET",
    }))
}

export const update_role_by_id = async (role_id, payload) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role/id/${role_id}`,
        method: "PUT",
        body: JSON.stringify(payload),
    }))
}

export const delete_role_by_id = async (role_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role/id/${role_id}`,
        method: "DELETE",
    }))
}

export const assign_role = async (payload) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role/assign`,
        method: "POST",
        body: JSON.stringify(payload),
    }))
}

export const duplicate_role_by_id = async (role_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/role/duplicate`,
        method: "POST",
        body: JSON.stringify({ role_id }),
    }))
}

